<script>
import { OverlayManager } from "../overlay-manager.js";
export default {
  name: "LoadingBase",
  props: {
    text: {
      type: String,
      default: "Loading...",
    },
    color: {
      type: String,
      default: "primary",
    },
    type: {
      type: String,
      default: "spinner",
    },
  },
  mounted() {
    this.id = OverlayManager.register(this);
  },
  computed: {
    animateClass() {
      switch (this.type) {
        case "spinner":
          return "spinner-border";
        case "grow":
          return "spinner-grow";
      }
      return "spinner-border";
    },
    colorClass() {
      switch (this.color) {
        case "primary":
          return "text-primary";
        case "secondary":
          return "text-secondary";
        case "success":
          return "text-success";
        case "danger":
          return "text-danger";
        case "warning":
          return "text-warning";
        case "info":
          return "text-info";
        case "light":
          return "text-light";
        case "dark":
          return "text-dark";
      }
      return "text-primary";
    },
  },
  methods: {
    close() {
      OverlayManager.close(this.id);
    },
    handleEscapePress() {},
    handleOverlayClick() {},
  },
};
</script>
<template>
  <div class="mhi-modal-wrapper">
    <div class="mhi-modal-body loader">
      <div :class="[animateClass, colorClass]" role="status"></div>
      <span class="loader-text">{{ text }}</span>
    </div>
  </div>
</template>
